export const feedbackSchema = {
    $id: 'urn:wisepipe-domain-authorize:Feedback',
    type: 'object',
    properties: {
        feedback: { type: 'string', minLength: 1 }
    },
    required: ['feedback']
};
//# sourceMappingURL=feedback.js.map